import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../../../models/User';

@Component({
  selector: 'app-mfa',
  templateUrl: './app-mfa.html'
})
export class AppMfa implements OnInit {
  @Input() data;
  isFreemium: boolean;

  constructor(private _user: User) {}

  ngOnInit() {
    this.isFreemium = this._user.isFreemium();
  }
}
